import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import { ForceDisputeOutcomeRequest, TransactionResponse } from './transactions.types';

export const getTransaction = async (apiAprilBaseUri: string, transactionId: string): Promise<TransactionResponse> => {
  const options = await getFetchOptions('GET');

  return await fetch(`${apiAprilBaseUri}/transactions/${transactionId}`, options).then(handleResponse);
};

export const administerTransaction = async (
  apiAprilBaseUri: string,
  transactionId: string,
  payload: ForceDisputeOutcomeRequest,
): Promise<TransactionResponse> => {
  const options = await getFetchOptions('PATCH', JSON.stringify(payload));

  return await fetch(`${apiAprilBaseUri}/transactions/enterprise/${transactionId}`, options).then(handleResponse);
};
